import React, { useContext } from "react";
import { useLoaderData } from "react-router-dom";
import { AuthContext } from "../../context/UserContext";

const  Premium = () => {

    const {user} = useContext(AuthContext);

  const data = useLoaderData();
  console.log(data);
  return (
    <div className="container mt-5 mb-5">
      <div>
        <h1 className="text-center text-primary">
          This is page is Premium for{" "}
          <span className="text-warning">{data.name}</span>
        </h1>
      </div>

      <div className="text-center mt-5 mb-5">
        <img
          className="text-center w-50 rounded-4 shadow-lg mb-5"
          src={data.logo}
          alt=""
        ></img>
      </div>
        <div className="d-flex ">
          <h4 > {user?.displayName ? (<p className="text-success">User Name : {user?.displayName}</p>) : <p className="text-danger">None</p>} </h4>

        </div>
        <div className="d-flex">
          <h4>{user?.email ? (<p className="text-success">User Email : {user?.email}</p>) : <p className="text-danger">User Email : None</p>}</h4>
          
      </div>
    </div>
  );
};

export default Premium;
